<template>
  <v-layout>
    <v-flex xs12>
      <v-layout v-if="visa_number && is_latest">
        <v-flex xs11>
          <confirmation-header-text class="ml-2" icon="mdi-file-document" text="Documents"/>
        </v-flex>
        <v-flex xs1>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                  color="primary"
                  small
                  dark
                  dense
                  @click="addNewDoc"
                  fab
                  width="30"
                  height="30"
                  v-on="on"
                  x-small
              >
                <v-icon small>add</v-icon>
              </v-btn>
            </template>
            <span>Add Document</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <confirmation-header-text class="ml-2" icon="mdi-file-document" text="Documents" v-else/>
      <v-layout class="pl-6" row v-for="document in document_list" wrap>
        <v-flex sm2>
          <list-item-detail
              :sub_title="document && document.document_type ? document.document_type : document.type ? document.type.name  : 'N/A'"
              title="Document Name"
          />
        </v-flex>

        <v-flex sm1>
          <list-item-detail
              :sub_title="(document.document_number?document.document_number:document.number?document.number:'n/a'+ ' (' + document.number_bkp + ' )')"
              title="Document Number"
          />
        </v-flex>

        <v-flex sm2>
          <list-item-detail
              :sub_title="(document.validity?document.validity:'n/a')"
              title="Expiry Date"
          />
        </v-flex>
        <v-flex sm4>
          <list-item-detail
            :sub_title="document.document_holding_country ? document.document_holding_country.country_name : (traveller ? traveller.country_name : 'N/A')"
              title="Document Holding Country"
          />
        </v-flex>
        <v-flex sm2>
          <file-list-item-detail :src="document.document" sub_title="Attachment"></file-list-item-detail>
        </v-flex>
        <v-flex sm1 class="mt-3" v-if="document.lost_at">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                  color="red lighten-1"
                  dark
                  v-on="on"
                  fab
                  dense
                  class="ml-2"
                  x-small
                  @click="undoDocumentLost(document)"
              >
                <v-icon small>close</v-icon>
              </v-btn>
            </template>
            <span>Undo</span>
          </v-tooltip>
        </v-flex>
        <v-flex sm1 xs1 v-if="showBtn" class="mt-3">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                  color="primary"
                  small
                  @click="editAttachment(document)"
                  v-if="!(document.document_type && document.document_type.toLowerCase().includes('passport'))"
                  dark
                  dense
                  fab
                  width="30"
                  height="30"
                  v-on="on"
                  x-small
              >
                <v-icon small>edit</v-icon>
              </v-btn>
            </template>
            <span>Edit Document</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-if="$oauth.checkIfHasPermission(['alter attached-document'])"
        v-model="attachmentDialog"
        width="700"
    >
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title v-if="visa_number">Add New Document</v-toolbar-title>
          <v-toolbar-title v-else>Edit {{ document.document_type }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-container grid-list-md class="pb-0">
            <v-layout wrap>
              <form-error-display-handler :errors="errors"/>
              <v-flex xs12>
                <v-form class="pa-2" lazy-validation ref="formRef">
                  <v-flex xs12 v-if="visa_number">
                    <v-select
                        :items="passportTypes"
                        :rules="[rules.required]"
                        label="Passport Type *"
                        outlined
                        v-model="document.document_type"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        type="text"
                        :rules="[rules.required]"
                        v-model="document.document_number"
                        label="Document Number "
                        outlined
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        type="date"
                        :rules="[rules.required]"
                        v-model="document.validity"
                        label="Expiry Date "
                        outlined
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-autocomplete
                        :clearable="true"
                        :items="all"
                        :rules="[rules.required]"
                        item-text="country_name"
                        item-value="id"
                        label="Select Document Holding Country *"
                        outlined
                        v-model="document.document_country_id"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                    <file-input
                        :imageUrl="document.document"
                        v-model="document.file"
                        placeholder="JPG, PNG, JPEG, PDF & DOCX ONLY"
                        label="Attach Document"
                    ></file-input>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="attachmentDialog=false" class="white--text" color="red lighten-1">Cancel</v-btn>
          <v-btn :loading="loading" @click="save" class="white--text" color="blue darken-3">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ListItemDetail from "../components/ListItemDetail";
import FileListItemDetail from "../components/FileListItemDetail";
import ConfirmationHeaderText from "../components/ConfirmationHeaderText";
import FileInput from "../components/FileInput";
import FormErrorDisplayHandler from "../components/FormErrorDisplayHandler";
import Http from "axios";
import {VERSIONED_API_URL} from "../config/config";
import {passportTypes} from "../constants/AppConstant";
import {validationMixin} from "../mixins/validationMixin";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AttachedDocument",
  data() {
    return {
      attachmentDialog: false,
      document: {
        type: ""
      },
      loading: false,
      errors: [],
      passportTypes
    };
  },
  mixins: [validationMixin],
  props: ["document_list", "showBtn", "visa_number", "submission_number", "is_latest", "traveller"],
  components: {
    ListItemDetail,
    ConfirmationHeaderText,
    FileListItemDetail,
    FileInput,
    FormErrorDisplayHandler
  },
  methods: {
    ...mapActions("CountryList", ['fetchAllCountries']),
    undoDocumentLost(item) {
      let formData = new FormData();
      formData.set('document_id', item.id)
      Http.post(`${VERSIONED_API_URL}/visa/document/undo`, formData)
          .then(() => {
            this.loading = false;
            this.$store.commit(
                "Notification/showSuccess",
                "Document successfully undo"
            );
            this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail', this.$route.params.id);
          })
          .catch(err => {
            this.loading = false;
            this.$store.commit(
                "Notification/showError",
                err.response.data.message
            );
          });
    },
    addNewDoc() {
      this.passportTypes.push("Travel document");
      this.attachmentDialog = true;
    },
    editAttachment(item) {
      this.document = item;
      this.attachmentDialog = true;
    },
    save() {
      if (this.visa_number) this.addNewDocument();
      else this.updateDocument();
    },
    addNewDocument() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        let traveller = this.traveller || this.$store.state.VisaRequestSingle.visaRequest.traveller;
        let formData = new FormData();
        // formData.set('visa_number', visa);
        formData.set("traveller", traveller.id);
        formData.set("visa_number", this.visa_number);
        formData.set("submission_number", this.submission_number);
        formData.set("document_type", this.document.document_type);
        formData.set("document_country_id", this.document.document_country_id);
        if (this.document.file !== undefined && this.document.file !== null)
          formData.set("document", this.document.file);
        if (this.document.document_number)
          formData.set("document_number", this.document.document_number);
        if (this.document.validity)
          formData.set("validity", this.document.validity);
        Http.post(`${VERSIONED_API_URL}/visa/document/add`, formData)
            .then(() => {
              this.loading = false;
              this.attachmentDialog = false;
              this.$store.commit(
                  "Notification/showSuccess",
                  "Document successfully added"
              );
              let docs = this.document_list;
              docs.push(this.document);
              this.document = {
                type: ""
              };
              // this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail',this.$route.params.id);
            })
            .catch(err => {
              this.loading = false;
              if (err.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.attachmentDialog = false;
              this.$store.commit(
                  "Notification/showError",
                  err.response.data.message
              );
            });
      }
    },
    updateDocument() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        let id = this.$store.state.VisaRequestSingle.visaRequest.id;
        let formData = new FormData();
        formData.set("document_type", this.document.document_type);
        if (this.document.file !== undefined && this.document.file !== null)
          formData.set("document", this.document.file);
        if (this.document.document_number)
          formData.set("document_number", this.document.document_number);
        if (this.document.validity)
          formData.set("validity", this.document.validity);
        Http.post(
            `${VERSIONED_API_URL}/visa-requests/document/${id}/update`,
            formData
        )
            .then(() => {
              this.loading = false;
              this.attachmentDialog = false;
              this.$store.commit(
                  "Notification/showSuccess",
                  "Document successfully updated"
              );
              // this.$store.dispatch('VisaRequestSingle/getVisaRequestDetail',this.$route.params.id);
            })
            .catch(err => {
              this.loading = false;
              if (err.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.errors = err.response.errors;
              this.attachmentDialog = false;
              this.$store.commit(
                  "Notification/showError",
                  "Something went wrong"
              );
            });
      }
    }
  },
  computed: {
    ...mapGetters('CountryList', ['all'])
  },
  mounted() {
    this.fetchAllCountries()
  }
};
</script>
